import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const modalCloseFn = /* @__PURE__ */ createRecipe('modal-close', {}, [])

const modalCloseVariantMap = {}

const modalCloseVariantKeys = Object.keys(modalCloseVariantMap)

export const modalClose = /* @__PURE__ */ Object.assign(memo(modalCloseFn.recipeFn), {
  __recipe__: true,
  __name__: 'modalClose',
  __getCompoundVariantCss__: modalCloseFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: modalCloseVariantKeys,
  variantMap: modalCloseVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, modalCloseVariantKeys)
  },
  getVariantProps: modalCloseFn.getVariantProps,
})